import { Effect } from 'effect';

import { reactivityKeys } from '../../reactivityKeys';
import { RuntimeClientAtom } from '../../../runtime/RuntimeClient';
import { AuthToken } from '../../../service/auth/AuthToken';
import { StorageSync } from '../../../service/auth/StorageSync';

export const removeAuthTokenAtomFn = RuntimeClientAtom.fn(
  Effect.fnUntraced(function* () {
    const authTokenService = yield* AuthToken;
    const storageSync = yield* StorageSync;
    yield* authTokenService.removeAllTokens;
    yield* storageSync.broadcastTokensCleared;
    return;
  }),
  {
    reactivityKeys: [reactivityKeys.authToken, reactivityKeys.customer],
  }
);
